<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <card class="card">
          <div class="d-flex justify-content-between">
            <h4 slot="header" class="card-title">
              Campanhas
              <p class="category" style="text-transform:none;">
                Crie aqui sua campanha de pesquisas
              </p>
            </h4>
            <div class="d-flex align-items-center">
              <button class="btn btn-info btn-sm" @click="visibilityStates.createVisibility = true">
                Adicionar Campanha
              </button>
            </div>
          </div>

          <Table :tableData="campaignsTableData" :hasDetails="true" :data="campaigns" :columns="['id', 'name', 'type', 'createdAt']" :actions="[]" @pagechanged="onPageChange">
            <template v-slot:default="slotProps">
              <router-link :to="{ path: `campanhas/${slotProps.campaign.id}` }">{{ slotProps.campaign.name || 'sem nome' }}</router-link>
            </template>
          </Table>
          <ListLoader v-if="campaignsTableData.loading" :height="40" :amount="8"></ListLoader>
          <Error v-if="!campaignsTableData.loading && campaignsTableData.error"></Error>
          <Empty v-if="!campaignsTableData.loading && !campaignsTableData.error && campaigns.length === 0"></Empty>
        </card>
      </div>
    </div>

    <!-- Modal Add -->
    <Modal v-model="visibilityStates.createVisibility" successMessage="Campanha criada com sucesso!" action="Adicionar" title="Adicionar Campanha" @closeModal="visibilityStates.createVisibility = false" @confirmAction="create(newCampaign.name, newCampaign.type)">
      <template v-slot:body>
        <div class="form-group">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="newCampaign.name" />
        </div>

        <div class="form-group">
          <label>Tipo</label>
          <input type="text" class="form-control" v-model="newCampaign.type" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/components/Modal/Modal';
import Table from '@/components/Common/Table';
export default {
  components: {
    Modal,
    Table,
  },
  data() {
    return {
      newCampaign: {
        name: '',
        type: '',
      },
      visibilityStates: {
        createVisibility: false,
      },
    };
  },
  computed: {
    campaigns() {
      return this.$store.getters['campaigns/get'];
    },
    campaignsTableData() {
      return this.$store.getters['campaigns/getCampaignsTableData'];
    },
    campaign() {
      return this.$store.getters['campaigns/getCampaign'];
    },
  },
  methods: {
    /** Create */
    openCreateModal: function() {
      this.visibilityStates.createVisibility = true;
    },
    create: async function(name, type) {
      await this.$store.dispatch('campaigns/create', { name: name, type: type });
      this.visibilityStates.createVisibility = false;
      this.newCampaign = {};
    },
    normalizerBrand(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },
    normalizerTip(node) {
      return {
        id: node.id,
        label: node.text,
      };
    },
    onPageChange(page) {
      this.$store.dispatch('campaigns/setPage', page);
    },
  },
  mounted() {
    this.$store.dispatch('campaigns/get');
  },
};
</script>
